import React from 'react';

import classes from './Button.module.css';

const triangle = (props) => (
    <div className={classes.TriangleRight}>
    </div>
);

export default triangle;